import { ApiManager } from 'utlis/api_manager';

const api = new ApiManager(process.env.REACT_APP_BASE_URL, 1);
const invitationsUrl = 'project/team/workspace-invitations';

// Public endpoint — no auth required. Returns invitation details regardless of status
// (pending / accepted / cancelled / expired) so the FE can show appropriate messaging.
export const getInvitationPreview = async token => {
  const { data } = await api.setUrl(`${invitationsUrl}/${token}`).get();

  return data;
};

// Authenticated endpoint. Returns the joined workspace on success.
export const acceptInvitation = async token => {
  const { data } = await api
    .setUrl(`${invitationsUrl}/${token}/accept`)
    .post({});

  return data;
};
